<script>
  import {router} from 'tinro';
  import {Nav,Button,Card,Icon} from 'svelte-chota';  
  import {mdiChevronDown} from '@mdi/js';  
  import user from './../stores/user.js';
  import {api} from './../lib/api.js'; 

  let open = false;

  async function signout(){
    await api.delete('/user/auth'); 
    user.fetch();
  }

  function closeAction(node){
    const handler = _ => open=false;


    window.addEventListener('click',handler);
    return {
      destroy: ()=>window.removeEventListener('click',handler)
    }
  }

</script>

<Nav>
  <a  slot="left" class="brand" href="/">Expatrix</a><span slot="left">Developers Zone</span><div slot="right">
    {#if !$user || $user.error}
      <Button outline primary>Login</Button>
    {:else}
      <span class="account" on:click|stopPropagation={()=>open=true}>{$user.user} <Icon src={mdiChevronDown} rotate={open ? 180 : 0}/></span>
    {/if}
  </div>
</Nav>

{#if open}
<div class="dropdown" use:closeAction>
  <Card>
    <ul>
      <li><a href="/projects">My projects</a></li>
      {#if $user.admin}
      <hr>
      <li><a href="/admin/users">Manage users</a></li>
      <li><a href="/admin/projects">Manage projects</a></li>
      {/if}
      <hr>
      <li><a href="/" on:click|preventDefault={signout}>Sign out</a></li>
    </ul>
  </Card>
</div>
{/if}

  <style>
      span{
          font-size: 25px;
          font-weight: 100;
          align-self: center;
      }

      p{margin:0px; padding:0px;}

      .account{
        display: inline-block;
        font-size: 18px;
        color: var(--color-primary);
        cursor: pointer;
        margin: 10px;
        font-weight: 300;
      }

      .dropdown{
        position: absolute;
        max-height: 200px;
        right: 10px;
        top: 40px;
        z-index: 100000000;
      }

      .dropdown ul,.dropdown li{
        margin: 0px;
        padding: 0px;
      }

      .dropdown li{
        list-style: none;
      }
  </style>